import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-notifications",
  "use": "gw-notifications-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-notifications\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2Zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71L18 16Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol